import { cloneElement, Fragment } from 'react';

import { getElements } from '@/utils/hooks/format/formatCaptionText/utils/getElement';

const tagRegex = /<(\w+)>(.*?)<\/\1>|<(\w+)\/>/;
const newLineRegex = /(?:\r\n|\r|\n)/g;

export function formatElements(
    value: string,
    elements: React.ReactElement[] | Record<string, React.ReactElement>
): React.ReactNode[] | React.ReactNode {
    const parts = value?.replace(newLineRegex, '')?.split(tagRegex);

    if (parts?.length === 1) return value;

    const tree: React.ReactNode[] = [];
    const before = parts?.shift();
    if (before) tree?.push(before);

    getElements(parts)?.forEach(([key, children, after], realIndex) => {
        const element = (elements[key] || <Fragment />) as React.ReactElement;

        tree?.push(
            cloneElement(
                element,
                { key: realIndex },
                children
                    ? formatElements(children, elements)
                    : (element.props as { children?: React.ReactNode }).children
            )
        );

        if (after) tree?.push(after);
    });

    return tree;
}
